<template>
  <div class="container_wrapper">
    <left-menu title="风资源参数分析" module-type="analysis"></left-menu>
    <main-content></main-content>
  </div>
</template>
<script>
import leftMenu from '../components/left-menu';
import mainContent from './content';
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    leftMenu,
    mainContent
  }
};
</script>

<style></style>
